import template from './loadingExclusions.html';
import controller from './loadingExclusionsCtrl.js';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    tab: '<',
    filterData: '<',
    dateSentFeature: '<',
    filterUpdateCount: '<',
    refreshCount: '<',
    onTableDataLoaded: '&',
    onSendModal: '&',
    viewContact: '&',
  },
};
